
<div style="text-align: center">
    <v-icon :size = "size" :color = "color" class="document-icon mt-1">
        {{ icon }}
    </v-icon>
</div>
